const GEO_DETAILS = 'GEO_DETAILS';
export {
    GEO_DETAILS,
}